import controller from './box-products.controller';
import templateT1 from './templates/box-products-t1.view.html';
import templateAD from './templates/box-products-adaptative.html';

let BoxProductsComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<',
        itemName: '@'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');

  if(__env.adaptative){
    return templateAD;
  }else{
      return templateT1
  }
}

export default BoxProductsComponent;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/box-products/box-products.component.js
 **/